import React, { Component } from 'react';
import { Row, Col, InputGroup, Label, Button } from "reactstrap";
import { observer } from "mobx-react";
import CalendarioPicker from '../../../comum/components/Calendario';
import { FecharFiltro, Filtro } from "../../../comum/components/Icones";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import Card from "../../../comum/components/Card";
import FormInputSimples from "../../../comum/components/FormInputSimples";

@observer
export default class FiltrosAgServico extends Component {
    constructor(props) {
        super(props);

        this.controller = this.props.controller
        this.state = { maisFiltros: false, filtrado: false };
        this.mensagemObrigatorio = "Esse campo é obrigatório";
    }

    handleFiltrar = () => {
        this.setState(state => ({ filtrado: true }));
        this.controller.listarAgendamentos();
    };

    validar = () => {
        return (
            this.controller.filtroValor.grupos
        );
    };

    filtros = () => {
        if (!this.state.maisFiltros) {
            return this.filtrosBasicos();
        } else {
            return this.filtrosCompletos();
        }
    };

    filtrosBasicos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
            <Col className={`col-botoes ${(!this.validar() && this.state.filtrado) ? "filtrado" : ""}`} xl={3} lg={3} md={3} sm={12} xs={12}>
                <Button className="btn-filtros" onClick={() => this.mudaFiltros()} outline>
                    <Filtro color="#93A0AD" className="mr-2" width="15" height="15" />
                    Mais filtros
                </Button>
                {this.botaoFiltrar()}
            </Col>
        </React.Fragment>
    };

    filtrosCompletos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
                    <FormInputSimples titulo="Container" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        onEnter={() => this.handleFiltrar()}
                        onChange={(event) => this.controller.setFilter("container", event.target.value)}
                    />
                    <FormSelectSimples titulo="Cliente" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                    itens={this.controller.filtroListar.cliente}
                                    dado={this.controller.filtroValor.cliente}
                                    bloqueado={!this.controller.filtroListar.cliente}
                                    onChange={(event) => this.controller.setFilter('cliente', event)} />
                    <Col className="col-botoes" xl={xl} md={md} sm={12} xs={12}>
                        <Button className="btn-filtros ativo" onClick={() => this.mudaFiltros()} outline>
                            <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15" />
                            Menos filtros
                        </Button>
                        {this.botaoFiltrar()}
                    </Col>
                </React.Fragment>
    };

    filtrosObrigatorios = () => {
        let xl = 2; let lg = 4; let md = 4;
        return (
            <React.Fragment>
                <FormSelectSimples titulo="Grupo" xl={3} lg={3} md={md} sm={12} xs={12}
                                   itens={this.controller.filtroListar.grupos}
                                   dado={this.controller.filtroValor.grupos}                                   
                                   bloqueado={!this.controller.filtroListar.grupos}
                                   onChange={(event) => this.controller.onChangeFiltroGrupos(event)} />

                <FormSelectSimples titulo="Tipo" xl={3} lg={3} md={md} sm={12} xs={12}
                                   itens={this.controller.filtroListar.tiposGrupos}
                                   dado={this.controller.filtroValor.tiposGrupos}
                                   bloqueado={!this.controller.filtroListar.tiposGrupos}                                   
                                   onChange={(event) => this.controller.setFilter('tiposGrupos', event)} />

                <Col xl={xl} lg={lg} md={md} sm={12} xs={12} className="mb-4">
                    <div className="w-100">
                        <Col xs={12} className="col-label px-0">
                            <Label>Período</Label>
                        </Col>
                        <Col xs={12} className="px-0">
                            <InputGroup className={'ativo'}>
                                <CalendarioPicker
                                    onChangeInicio={valor => this.controller.setFilter('dataInicial', valor)}
                                    onChangeFim={valor => this.controller.setFilter('dataFinal', valor)}
                                    dataInicial={this.controller.filtroValor.dataInicial}
                                    dataFinal={this.controller.filtroValor.dataFinal}
                                    close={true}
                                    filtrar={() => { }} />
                            </InputGroup>
                        </Col>
                    </div>
                </Col>
                <FormInputSimples titulo="BL" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                  alerta={''}
                                  limiteMaximo={100}
                                  onEnter={() => this.handleFiltrar()}
                                  onChange={(event) => this.controller.setFilter("numeroBL", event.target.value)}
                />
                <FormSelectSimples titulo="Status" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                   itens={this.controller.filtroListar.status}
                                   dado={this.controller.filtroValor.status}
                                   onChange={(event) => this.controller.setFilter('status', event)}
                />
            </React.Fragment>
        );
    }

    botaoFiltrar = () => {
        return (<Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.handleFiltrar()}>Filtrar</Button>);
    }
    mudaFiltros = () => {
        this.setState({ maisFiltros: !this.state.maisFiltros });
    };

    render() {
        return (
            <div className={this.controller.detalhesAtivo ? "escondido" : "filtro-card"} >
                <Card className={"area-form pb-0"}>
                    <Row className="pb-0">
                        {this.filtrosObrigatorios()}
                        {this.filtros()}
                    </Row>
                </Card>
            </div>)
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamentoservicos/visualizar/components/FiltrosAgServicos.js